import React, { useState } from 'react';
import styles from './select.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';

const Select = ({ options, onSelect }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState('');

    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    const handleOptionSelect = (option) => {
        setSelectedOption(option);
        setIsOpen(false);
        onSelect(option);
    };

    return (
        <div className={styles.select}>
            <div className={styles.select_input} onClick={handleToggle}>
                <div>
                    {selectedOption ? selectedOption.label : "Select ..."}
                </div>
                <FontAwesomeIcon icon={faAngleDown} />
            </div>
            {isOpen && (
                <ul className={styles.select_options}>
                    <li
                        key=""
                        className={styles.select_option}
                        onClick={() => handleOptionSelect('')}
                    >
                        Select...
                    </li>
                    {options.map((option) => (
                        <li
                            key={option.value}
                            className={styles.select_option}
                            onClick={() => handleOptionSelect(option)}
                        >
                            {option.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default Select;